class Promotion {

    static FREE_SHIPPING = "freeshipping_promotion";
    static BUY_X_GET_Y = "buy_x_get_y_promotion";
    static AMOUT_SPENT = "amount_spent_get_gift_promotion";

    static ACTIVE = "active";
    static NOT_ACTIVE = "not-active";
    static USED = "used";
    static NOT_USED = "not-used";

    static PROMOTION_HANDLE = "_promotion";
    static IS_PROMOTION = "_is_promotion";

    constructor(data) {
        this.type = data.type;
        this.handle = data.handle;
        this.promo = {
            object_name: data.promo.object_name,
            products_to_buy: data.promo.products_to_buy || [],
            product_quantity: data.promo.product_quantity,
            variants_to_get: data.promo.variants_to_get,
            products_to_get: data.promo.products_to_get,
            custom_thresholds: data.promo.custom_thresholds,
        };
        this.available_product_variants = data.available_product_variants || {};
    }

    hasOneVariant() {
        return Object.keys(this.available_product_variants).length > 0 || this.promo.variants_to_get
    }

    /**
     * Check if the promotion has a single variant available, if so return it
     * @returns {string?}
     */
    getSingleVariant() {
        if (this.promo.variants_to_get?.length == 1 && !this.promo.products_to_get)
            return this.promo.variants_to_get[0];
        else if ((this.promo.products_to_get?.length) == 1 && (this.available_product_variants[this.promo.products_to_get[0]]?.length == 1))
            return this.available_product_variants[this.promo.products_to_get[0]][0];
        return null;
    }

    getThreshold(country) {
        return this.promo.custom_thresholds[country] || null;
    }
}
class PromotionsUtils {
    static async getCart() {
        try {
            const response = await fetch(`${KROWN.settings.routes.cart_url}.js`, { method: 'GET' });
            return await response.json();
        } catch (error) { console.error('Error:', error); }
    }

     /**
     * Add a product variant to the cart
     * @param {Promotion} promotion
     * @param {String} variant
     * @param {Number} quantity
     * @returns {Object} cart/add response
     */
    static async addToCart(promotion, variant, quantity = 1) {
        const formData = {
            'items': [{
                'id': variant.split('gid://shopify/ProductVariant/')[1],
                'quantity': quantity,
                'properties': {
                    [Promotion.PROMOTION_HANDLE] : promotion.handle,
                    [Promotion.IS_PROMOTION]: true
                }
            }]
        };

        try {
            return await fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
                body: JSON.stringify(formData),
                headers: { 'Content-Type': 'application/json' },
                method: 'POST'
            });
        } catch (error) { console.error('Error adding to cart: ', error) }
    }

    static getChangePromise(index, quantity, properties) {
        return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                line: index,
                quantity: quantity,
                properties: properties
            })
        });
    }

    static getCartPromise(attributes) {
        return fetch('/cart/update.js', {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify({ attributes: attributes })
        });
    }
}
if (!customElements.get('promotions-handler')) {
  class PromotionsHandler extends HTMLElement {
      constructor() {
          super();
          this.cart = {};

          this.queue = [];
      }

      get activePromos() {
          return JSON.parse(this.querySelector('[data-active-promotions]').innerHTML).map(promo => new Promotion(promo));
      }

      /**
       * Subscribe to the cart update event
       */
      connectedCallback() {
          this.handleCartUpdate();
          this.subscriber = subscribe(PUB_SUB_EVENTS.cartUpdated, () => {
            this.handleCartUpdate();
          });
      }

      disconnectedCallback() {
          this.subscriber && this.subscriber();
      }

      /**
       * - Update the stored cart object
       * - Handle the update based on the active promotions, skip if there's no active promotion
       */
      async handleCartUpdate() {
        this.queue = [];
        for (const promotion of this.activePromos) {
          this.cart = await PromotionsUtils.getCart();
          switch (promotion.type) {
              case Promotion.AMOUT_SPENT:
                  await this.handleAmountSpentPromotion(promotion);
                  break;
              case Promotion.BUY_X_GET_Y:
                  await this.handleBuyXPromotion(promotion);
                  break;
              default:
                  break;
          }
        }

        await document.querySelector('product-form')?.renderCart();
        publish(PUB_SUB_EVENTS.promotionAvailable, this.queue);
      }


      /**
       * Handle the "amount_spent_get_gift_promotion" case
       * @param {Promotion} promotion
       */
      async handleAmountSpentPromotion(promotion) {
          const country = this.dataset.country || 'IT';
          if (promotion.getThreshold(country) == null) return;
          let fire = promotion.getThreshold(country) != null && (((this.cart.total_price / 100) >= promotion.getThreshold(country)));
          return await this.processPromotionProducts(promotion, fire);
      }


      /**
       * Handle the "buy_x_get_y_promotion" case
       * @param {Promotion} promotion
       */
      async handleBuyXPromotion(promotion) {
          let qty = 0;
          this.cart.items?.forEach((cartItem) => {
              promotion.promo.products_to_buy = typeof promotion.promo.products_to_buy === 'string' ? [promotion.promo.products_to_buy] : promotion.promo.products_to_buy;
              promotion.promo.products_to_buy.forEach((prodToBuy) => {
                  prodToBuy.includes('gid://shopify/Product/' + cartItem.product_id) && (qty += cartItem.quantity);
              });
          })
          return await this.processPromotionProducts(promotion, qty >= promotion.promo.product_quantity)
      }


      /**
       * Check if there are available variants, if not return
       *
       * If there are variants available, this is the logic to process the promotion products:
       *- if there's a single variant,                    `add to cart`
      *- if there are multiple variants,                 `publish event`
      *- if a product has a single variant,              `add to cart`
      *- if a product has multiple available variants,   `publish event`
      * @param {Promotion} promotion
      * @param {Boolean} fire
      */
      async processPromotionProducts(promotion, fire = false) {
          if (!promotion.hasOneVariant()) return;

          const currentItems = [];
          this.cart.items?.forEach((item) => {
              if (item.properties[Promotion.PROMOTION_HANDLE] == promotion.handle)
                  currentItems.push(item);
          });
          let status = this.cart.attributes[promotion.handle] == true || this.cart.attributes[promotion.handle] == "true"
              ? currentItems.length > 0
                ? Promotion.USED
                : Promotion.NOT_USED
              : fire
                ? Promotion.ACTIVE
                : Promotion.NOT_ACTIVE;
          if (fire) {
              const singleVariant = promotion.getSingleVariant();
              if (singleVariant && status != Promotion.NOT_USED && status != Promotion.USED) {
                await this.handleAddToCart(promotion, singleVariant) 
                status = Promotion.USED;
              }
          }
          else if (status == Promotion.USED) {
              await this.disablePromotion(promotion);
              status = Promotion.NOT_ACTIVE;
          }


          this.queue.push({
              'payload': {
                  'products_to_get': promotion.promo.products_to_get || [],
                  'variants_to_get': promotion.promo.variants_to_get || [],
                  'current_items': currentItems,
                  'triggered_promotion': promotion.handle,
                  'promotion-type': promotion.type,
                  'status': status
              }
          });
      }

      /**
       *
       * @param {Promotion} promotion
       */
      async updateTriggerItems(promotion) {
          const attributes = this.cart.attributes;
          attributes[promotion.handle] = true;

          await PromotionsUtils.getCartPromise(attributes);
      }

      async handleAddToCart(promotion, variant) {
          await PromotionsUtils.addToCart(promotion, variant);
          await this.updateTriggerItems(promotion);
      }

      /**
       *
       * @param {Promotion} promotion
       */
      async disablePromotion(promotion) {
          const updates = [];

          let removeItemIndex = 1;
          for (const item of this.cart.items) {
              const properties = item.properties || {};
              const isPromotionItem = properties._promotion === promotion.handle;

              if (isPromotionItem) await PromotionsUtils.getChangePromise(removeItemIndex, 0, properties);
              !isPromotionItem && removeItemIndex++; // ensures the index is shifted after removing a line item
          }

          const attributes = this.cart.attributes;
          attributes[promotion.handle] = false;

          updates.push(PromotionsUtils.getCartPromise(attributes));
          await Promise.all(updates);
      }
  }

  customElements.define('promotions-handler', PromotionsHandler);
}
if (!customElements.get('promotions-products-handler')) {
  class PromotionProductsHandler extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.promotions = this.querySelectorAll('[data-promotion]');

      this.subscriber = subscribe(PUB_SUB_EVENTS.promotionAvailable, (event) => {
        event.forEach(payload => this.validetePromotion(payload));
        this.sort();
      });

      this.querySelectorAll('[data-line]').forEach((link) => {
        link.addEventListener('click', async () => {
          document.getElementById("AjaxCartForm").updateCartQty(link, 0);
        });
      });
    }

    disconnectedCallback() {
      this.subscriber && this.subscriber();
    }


    sort() {
        const container = this.querySelector('[data-promotions-container]');
        const accordions = Array.from(container.querySelectorAll('cooder-accordion[data-promotion]'));
        accordions.sort((a, b) => {
          const aOpen = a.querySelector('details').hasAttribute('open');
          const bOpen = b.querySelector('details').hasAttribute('open');
          return bOpen - aOpen;
        });
        accordions.forEach(acc => container.appendChild(acc));
    }


    validetePromotion(event) {
      const trigger = event.payload.triggered_promotion;
      if (event.payload.status == Promotion.NOT_ACTIVE) {
          const promotion = this.querySelector(`[data-promotion="${trigger}"][data-not-active]`);
          promotion && promotion.toggleAttribute('hidden', false);
          return;
      }

      if (event.payload.status == Promotion.USED) {
        const promotion = this.querySelector(`cooder-accordion[data-promotion="${trigger}"]`);
        promotion && promotion.toggleAttribute('hidden', true);
        return;
      }

      const promotion = this.querySelector(`[data-promotion="${trigger}"]:not([data-not-active])`);
      if (!promotion) {
        return;
      }



      const products = event.payload.products_to_get || [];
      const variants = event.payload.variants_to_get || [];
      const items = event.payload.current_items || [];

      if (products.length == 0 && variants.length <= 1 && items != 0) return;

      for (let product of products) {
        product = product.split('/')[product.split('/').length - 1];
        const productElement = promotion.querySelector(`[data-id="${product}"]`);
        if (productElement) {
          productElement.toggleAttribute('hidden', false);
        }
      }

      for (let variant of variants) {
        variant = variant.split('/')[variant.split('/').length - 1];
        const variantElement = promotion.querySelector(`[data-id="${variant}"]`);
        if (variantElement) {
          variantElement.toggleAttribute('hidden', false);
        }
      }
      promotion.toggleAttribute('hidden', false);
    }

  }

  customElements.define('promotions-products-handler', PromotionProductsHandler);
}
//if (!customElements.get('product-variant-picker')) {
  class ProductVariantPicker extends HTMLElement {

    constructor() {
      super();
      this.handle = this.dataset.handle;
      this.form   = this.querySelector('[data-variant-form]');

      this.boundOnChange = this.onChange.bind(this);
    }

    connectedCallback() {
      this.form?.addEventListener('change', this.boundOnChange);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('change', this.boundOnChange);
    }

    onChange(event) {
      this.querySelector('[name="id"]').value = event.target.value;
    }

  }
  //customElements.define('product-variant-picker', ProductVariantPicker);
//}
if (!customElements.get('promotion-product')) {
  class PromotionProduct extends ProductVariantPicker {

    constructor() {
      super();
      this.handle = this.dataset.handle;
    }

    connectedCallback() {
      super.connectedCallback();
    }

    disconectedCallback() {
      super.disconnectedCallback();
    }

    onChange() {
      this.querySelector('[data-submit]').click();
    }

  }
  customElements.define('promotion-product', PromotionProduct);
}
if (!customElements.get('promotion-progress-bar')) {
  class PromotionProgressBar extends HTMLElement {
    constructor() {
      super();
      this.container = this.querySelector('[data-promo-container]');

      this.thresholds = [], this.labels = [];
      this.querySelectorAll('[data-promotion]').forEach(promotion => {
          this.thresholds.push(promotion.dataset.threshold / 100);
          this.labels.push(promotion.dataset.label);
      });

      this.bar         = this.container.querySelector('[data-bar-fill]');
      this.dynamicText = this.container.querySelector('[data-dynamic-text]');
      this.steps       = Array.from(this.container.querySelectorAll('[data-bar-step]'));

      const count = this.thresholds.length;
      this.slots = Array.from({ length: count }, (_, i) =>
          Math.round(((i + 1) * 100) / (count + 1))
      );
    }

    connectedCallback() {
      const raw = parseFloat(this.container.getAttribute('data-cart-total')) || 0;
      this.cartTotal = raw / 100;

      let fillRate;
      if (this.cartTotal <= this.thresholds[0])
        fillRate = this.cartTotal / this.thresholds[0] * this.slots[0];
      else if (this.cartTotal >= this.thresholds[this.thresholds.length-1])
        fillRate = 100;
      else {
        const idx = this.thresholds.findIndex(v => this.cartTotal <= v);
        const prevT = this.thresholds[idx-1], nextT = this.thresholds[idx];
        const prevSlot = this.slots[idx-1], nextSlot = this.slots[idx];
        const frac = (this.cartTotal - prevT) / (nextT - prevT);
        fillRate = prevSlot + frac * (nextSlot - prevSlot);
      }

      this.bar.style.width = `${fillRate}%`;

      const reached = this.thresholds.filter(v => this.cartTotal >= v);
      const nextIdx = this.thresholds.findIndex(v => this.cartTotal < v);

      if (nextIdx !== -1) {
        const rem = Math.ceil(this.thresholds[nextIdx] - this.cartTotal);
        this.dynamicText.innerHTML = window.KROWN.settings.progressbar.missing.replace('${replace}', rem).replace('${replace2}', this.labels[nextIdx]);
      }
      else {
        this.dynamicText.innerHTML = window.KROWN.settings.progressbar.congratulation.replace('${replace}', this.labels[this.labels.length - 1]);
      }

      this.steps.forEach((element, i) => {
        const threshold = this.thresholds[i];
        if (!threshold) { element.style.display = 'none'; return; }
        element.style.display = '';
        element.style.position = 'absolute';
        const s = this.slots[i];
        element.style.left = `${s}%`;
        element.style.transform = 'translateX(-50%)';
        element.toggleAttribute('active', fillRate >= s);
      });
    }
  }

  customElements.define('promotion-progress-bar', PromotionProgressBar);
}